import { render, staticRenderFns } from "./OtherAbsenceOutput.vue?vue&type=template&id=a063cf6e"
import script from "./OtherAbsenceOutput.vue?vue&type=script&lang=js"
export * from "./OtherAbsenceOutput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports